export default "__VITE_ASSET__BZ7lLLrI__"